import { find } from 'lodash';
import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';

const http = httpFactory({ baseURL: `${configurationURL.accounts.baseUrl}/accounts/0/` });

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getDefaultPaymentMethod = () =>
  http
    .get('/payment_methods', {
      ignore404: true,
    })
    .then(resp => find(resp.data, { default: true }));

/**
 * @param {String} nonce
 * @returns {Promise<AxiosResponse<any>>}
 */
export const savePaymentMethod = nonce =>
  http
    .post('/payment_methods', {
      nonce,
    })
    .then(resp => resp.data);

/**
 * @param {Number} version
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getClientToken = (version = 3) =>
  http
    .get('/payment_methods/client_token', {
      params: { version },
    })
    .then(resp => resp.data.token);

export default http;
